import _regeneratorRuntime from 'babel-runtime/regenerator';

// URI Parser from https://stackoverflow.com/a/39308026
var ParseURI = function ParseURI(url) {
  /* eslint-disable */
  var m = url.match(/^(([^:\/?#]+:)?(?:\/\/(([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/),
      r = {
    hash: m[8] || '', // #asd
    host: m[3] || '', // localhost:257
    hostname: m[4] || '', // localhost
    href: m[0] || '', // http://localhost:257/deploy/?asd=asd#asd
    origin: m[1] || '', // http://localhost:257
    pathname: m[6] || (m[1] ? '/' : ''), // /deploy/
    port: m[5] || '', // 257
    protocol: m[2] || '', // http:
    search: m[7] || '' // ?asd=asd
  };
  if (r.protocol.length === 2) {
    r.protocol = 'file:///' + r.protocol.toUpperCase();
    r.origin = r.protocol + '//' + r.host;
  }
  r.href = r.origin + r.pathname + r.search + r.hash;
  return m && r;
};

var _this = undefined;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _authWindow = null;
var _authWindowListener = null;
var _OAuthToken = null;

var _POLL_TIME = 500;

var cleanupAuthWindow = function cleanupAuthWindow() {
  if (_authWindow && _authWindow.close) {
    _authWindow.close();
  }
  _authWindow = null;
};

var removeAuthWindowListener = function removeAuthWindowListener() {
  if (_authWindowListener) {
    window.removeEventListener('message', _authWindowListener);
    _authWindowListener = null;
  }
};

var createAuthWindowListener = function createAuthWindowListener(OAuthURI, resolve, reject) {
  removeAuthWindowListener();
  return function authWindowListener(event) {
    var uri = ParseURI(OAuthURI);
    if (event.origin === '' + uri.origin) {
      var message = event.data;
      // reject the login promise if there's any oauth2 error from widget-server
      if (message && message.error) {
        removeAuthWindowListener();
        cleanupAuthWindow();
        reject(new Error('Veritone OAuth2 Error: ' + message.data));
        return;
      }

      // resolve the login promise if a token is present
      if (message && message.token) {
        _OAuthToken = message.token;
        removeAuthWindowListener();
        cleanupAuthWindow();
        resolve({ OAuthToken: _OAuthToken });
        return;
      }
    }
  };
};

var askOAuthServerForToken = function askOAuthServerForToken(OAuthURI, resolve, reject) {
  setTimeout(function () {
    // keep polling until we receive a response
    if (!_OAuthToken) {
      if (_authWindow) {
        _authWindow.postMessage('getOAuthToken', '*');
      }

      // if the auth window is closed, stop polling
      if (_authWindow && !_authWindow.closed) {
        askOAuthServerForToken(OAuthURI, resolve, reject);
      } else if (_authWindow && _authWindow.closed) {
        _authWindow = null;
        reject(new Error('User cancelled OAuth flow'));
      } else {
        removeAuthWindowListener();
        cleanupAuthWindow();
      }
    }
  }, _POLL_TIME);
};

var login = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(OAuthURI) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (OAuthURI) {
              _context.next = 2;
              break;
            }

            throw new Error('Missing parameter: Need to include the backend OAuth2 URI');

          case 2:
            if (!_OAuthToken) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return logout();

          case 5:

            _authWindow = window.open(OAuthURI, '_auth', 'width=550px,height=650px');
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              _authWindowListener = createAuthWindowListener(OAuthURI, resolve, reject);
              window.addEventListener('message', _authWindowListener);
              askOAuthServerForToken(OAuthURI, resolve, reject);
            }));

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function login(_x) {
    return _ref.apply(this, arguments);
  };
}();

var logout = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new Promise(function (resolve, reject) {
              removeAuthWindowListener();
              cleanupAuthWindow();

              // TO DO: Make a backend call to destroy the token
              _OAuthToken = null;
              resolve(true);
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function logout() {
    return _ref2.apply(this, arguments);
  };
}();

var handleImplicitRedirect = function handleImplicitRedirect() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hash;
  var opener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.opener;

  var OAuthToken = void 0,
      error = void 0;

  try {
    OAuthToken = hash.match(/access_token=(.+)$/)[1].split('&')[0];
  } catch (e) {
    /**/
  }

  if (!OAuthToken) {
    try {
      error = hash.match(/error=(.+)$/)[1].split('&')[0];
    } catch (e) {
      /**/
    }
  }

  opener.postMessage({
    OAuthToken: OAuthToken,
    error: error
  }, window.origin);
};

export { login, logout, handleImplicitRedirect };



//////////////////
// WEBPACK FOOTER
// ./~/veritone-oauth-helpers/dist/bundle-es.js
// module id = XBqv
// module chunks = 22